import React, {
  useState,
  useEffect,
  forwardRef,
  useRef,
} from "react";
// import profileimage from "src/Assets/images/profileimage.png";
import follow from "src/Assets/images/follow.svg";
import locationIcon from "src/Assets/images/userlocationtag.svg";
import dot from "src/Assets/images/dot.png";
import InviteFollowers from "./InviteFollowers";
// import smalllike from "src/Assets/images/like.svg";
import like from "src/Assets/images/like.svg";
import unlike from "src/Assets/images/unlike.svg";
import edit from "src/Assets/images/edit.svg";
// import share from "src/Assets/images/share.svg";
// import deleteicon from "src/Assets/images/deleteicon.png";
// import rating from "src/Assets/images/rating.svg";
import sendanemail from "src/Assets/images/sendanemail.png";
// import report from "src/Assets/images/report.png";
import privateinvite from "src/Assets/images/privateinvite.png";
// import sampledialogcancel from "src/Assets/images/Add.png";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
import { BsDot } from "react-icons/bs";
// import locationpinchildpost from "src/Assets/images/locationpinchildpost.png";
import styles from "src/Assets/css/home/post.module.css";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import EditLocation from "src/Utils/editLocation";
import activityStyle from "src/Assets/css/Activity/activity.module.css";
import { Divider } from "@material-ui/core";
// import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import unfollow from "src/Assets/images/unfollow.svg";
import SimpleDialogDemo from "../../../Modules/Reusuablecomponents/CustomizedDialogs";
import ReusuableDeleteDialogmodal from "../../../Modules/Reusuablecomponents/ReusuableDeleteModal";
import ReportModal from "../../../Modules/Reusuablecomponents/reportModal";
import PostMessageValidation from "../../../Modules/Reusuablecomponents/PostMessageValidation";
import MapDialog from "./LocationAddress";
import Childsay from "./ChildSay";
import API from "../../../network";
// import Dialog from "@material-ui/core/Dialog";
import { Modal } from "react-bootstrap";
import IconButton from "@material-ui/core/IconButton";
import { Menu, MenuItem } from "@szhsin/react-menu";
import AvatarBadge from "src/Components/AvatarBadge";
import TextWithUrlsAndHashTags from "src/Components/TextWithUrlsAndHashTags";
import { ProfileHoverCard } from "./ProfileHoverCard";
import replyIcon from "src/Assets/images/message new icon.png";
import answerIcon from "src/Assets/images/answerIcon.png";
import PopupComponent from "../../../Modules/Activity/Activites/Says Activity/PopupComponent";
import PostAttachmentViewer from "src/Utils/PostAttachmentViewer";
import AttachmentUploader from "src/Utils/AttachmentUploader";
import EditCalendarComponent from "src/Modules/Reusuablecomponents/EditCalendar";
import closeIcon from "src/Assets/images/CloseButton.svg";
import { PiDotsThreeBold } from "react-icons/pi";
import Tooltip from "@mui/material/Tooltip";
import ReusuableTagActionModal from "src/Utils/ReusuableTagActionModal";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";
import { ignoreSpacesAndUrlsFromMsg } from "src/Utils/commonUtils";

const Post = forwardRef(function MyPost(props, ref) {
  const {
    loading,
    data,
    isAskModal,
    childSaysData,
    fetchChildSaysData,
    followData,
    fetchFollowData,
    fetchVoteUpStatus,
    postChildSayData,
    fetchFeedData,
    deleteMessage,
    refreshFeedData,
    isPostOption,
    showData = "",
    allTagData,
    deleteAnswersToAsksDialogPost,
    deletePossibleAnswerToAskPost,
    deleteAsksToBeAnsweredDialogPost,
    flow,
    hasRestrictionSays,
    fetchContributors,
    onHashTagClick,
    isActionDisabled = false, // Default to false if not provided
    hideTenantName = false,
    parentMsgId = undefined,
    tagActivityTenantId = undefined,
    onActionSuccess
  } = props;

  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const isViewInfoAvailable =
    userDetails?.userData?.viewActivityUserTenantInfo &&
    Object.keys(userDetails.userData.viewActivityUserTenantInfo).length > 0;

  const hasParentMsgId = parentMsgId != null && parentMsgId !== "";
  const hasTagActivityTenantId =
    tagActivityTenantId != null && tagActivityTenantId !== "";

  const isModerator = isViewInfoAvailable
    ? userDetails.userData.viewActivityUserTenantInfo.isModerator == 1
    : userDetails.userData.moderatorStatus === "1";

  const shouldUseModeratorStatus =
    showData === "search" || hasParentMsgId || hasTagActivityTenantId;
  const [listdata, setListData] = useState([]);
  const [isRead, setIsRead] = useState(false);
  const [currentSayId, setCurrentSayId] = useState(null);
  const [openTextArea, setOpenTextArea] = useState(false);
  const [editPostId, setEditPostId] = useState(null);
  const [updatedMsg, setUpdatedMsg] = useState("");
  const [emailPopupOpen, setEmailPopupOpen] = useState(false);
  const [textValue, setTextValue] = useState("");
  const [textCount, setTextCount] = useState(0);
  const [selectedPost, setSelectedPost] = useState({});
  const [invitesShow, setInvitesShow] = useState(false);
  const [invite, setInvite] = useState(null);
  const [tenantId, setTenantId] = useState(null);
  const [msgId, setMsgId] = useState(null);
  const [charCount, setCharCount] = useState(0);
  const [errMsg, setErrMsg] = useState(null);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [locationAddress, setLocationAddress] = useState("");
  const [openMap, setOpenMap] = useState(false);
  const sayRefs = useRef([]);
  const [showUnfollowAlert, setShowUnfollowAlert] = useState(null);
  const [popupPostId, setPopPostId] = useState(null);
  const [popupData, setPopupData] = useState(null);
  const [open, setOpen] = useState(false);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [reminderDateAndTime, setReminderDateAndTime] = useState(null);
  const [attachment, setAttachment] = useState(null);
  const [isAttacmentDeleted, setIsAttacmentDeleted] = useState(null);

  const [clickedLocation, setClickedLocation] = useState({
    locAddress: "",
    latitude: "",
    longitude: "",
  });

  const [location, setLocation] = useState({
    selectedAddress: locationAddress,
    latitude: latitude,
    longitude: longitude,
  });

  // useImperativeHandle(
  //   ref,
  //   () => {
  //     return {
  //       setVisibleChildSays(id) {
  //         onSayClick(id);
  //       },
  //     };
  //   },
  //   []
  // );

  useEffect(() => {
    let msg = updatedMsg || "";
    // msg = msg.replace(/\n/g, "");
    // msg = msg.replace(/\s/g, "");
    const { msgLength } = ignoreSpacesAndUrlsFromMsg(msg);
    setCharCount(msgLength);
  }, [updatedMsg]);

  const handleLocationUpdate = (address, lat, lng) => {
    setLocation({
      selectedAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };
  const handleLocationDelete = () => {
    setLocation({
      selectedAddress: "",
      latitude: "",
      longitude: "",
    });
  };

  const handleClickOpen = (address, lat, lng) => {
    setOpenMap(true);
    setClickedLocation({
      locAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const handleCloseMap = () => {
    setOpenMap(false);
  };

  useEffect(() => {
    let msg = textValue || "";
    // msg = msg.replace(/\n/g, "");
    // msg = msg.replace(/\s/g, "");
    const count = msg.length;
    setTextCount(count);
  }, [textValue]);

  useEffect(() => {
    setListData(props.listdata);
  }, [props.listdata]);

  var profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  const onSendMail = async (id) => {
    if (textValue?.trim()) {
      console.log(`called111`)
      const response = await API.postMail(id, textValue);
      setEmailPopupOpen(false);
      if (response?.data?.justFollowed) {
        console.log(`called11133333`)
        onActionSuccess?.(() => {});
      }
    }
  };
  const setUpdatedText = (e) => {
    const newValue = e.target.value;
    setTextValue(newValue);
  };

  const onSayClick = (id, e) => {
    try {
      setIsRead(true);
      setCurrentSayId(id);
      let sayid = `saySelection${id}${props?.appendId ?? ""}`;
      e && e?.preventDefault();
      // const element = document.getElementById(sayid);
      // Access the specific ref from sayRefs
      const element = sayRefs.current[id]; // Index by id or index from the list
      if (element) {
        if (element.style.display === "block") {
          element.style.display = "none";
        } else {
          fetchChildSaysData(id);
          element.style.display = "block";
        }
      } else {
        console.warn(`Element with ID ${sayid} is not yet rendered.`);
      }
    } catch (e) {
      console.log("Error in onSayClick() method: " + e);
    }
  };

  const handleClickHashTag = async (parentId, id) => {
    try {
      const formData = new FormData();
      formData.append("id", parentId);
      formData.append("openQstatus", "SAYsQchild4");
      formData.append("mostlikedrepabuse", "mostliked");
      formData.append("parantId", "mostliked");
      const response = await API.getChildHashTag(formData);
      setPopupData(response.data); // Set the response data in state
      setOpen(true);
      setPopPostId(id);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onClosePopup = () => {
    setOpen(false);
    setPopPostId(null);
  };

  const updateList = (id, followStatus) => {
    const newData = [...listdata];
    const modifiedData = newData.find((x) => x.id === id);
    modifiedData.followStatus = followStatus.includes("0") ? "N" : "Y";
    modifiedData.followCount = followStatus.includes("0")
      ? modifiedData.followCount - 1
      : modifiedData.followCount - 1 + 2;
    setListData(newData);
  };

  const followunfollow = (id, followstatus) => {
    if (isActionDisabled) {
      return;
    } else {
      if (followstatus === "isFollow=0") {
        setShowUnfollowAlert({
          id,
          followstatus,
        });
      } else {
        followunfollowCallback(id, followstatus);
      }
    }
  };

  const followunfollowParentAskPost = async (id, followStatus, followCount) => {
    const newStatus = followCount === "1" ? "N" : "Y";
    const newPopupDataList = popupData.childQ.map((item) => {
      if (item.id === id) {
        const newFollowCount =
          followCount === "1" ? item.followCount - 1 : item.followCount + 1;
        return {
          ...item,
          followStatus: newStatus,
          followCount: newFollowCount,
        };
      } else {
        return item;
      }
    });
    setPopupData((prevData) => ({ ...prevData, childQ: newPopupDataList }));
    try {
      const response = await API.fetchFollowUnfollowData(id, followStatus);
      if (response?.data?.justFollowed) {
        onActionSuccess?.(() => {});
      }
    } catch (error) {
      console.error(error);
    }
  };

  const deletePopupMessage = async (id) => {
    try {
      const formdata = new FormData();
      formdata.append("messageID", id);
      await API.deleteAskTagPostUnderSayActivity(formdata);
      if (popupData?.childQ && Array.isArray(popupData.childQ)) {
        const newPopupDataList = popupData.childQ.filter(
          (item) => item.id !== id,
        );
        setPopupData((prevData) => ({ ...prevData, childQ: newPopupDataList }));
      } else {
        setPopupData(null);
      }
      onClosePopup();
      if (props.deleteMessage) {
        props.deleteMessage(id);
      }
      if (props.deletePossibleAnswerToAskPost) {
        props.deletePossibleAnswerToAskPost(id);
      }
      if (props.refreshFeedData) {
        props.refreshFeedData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const followunfollowCallback = (id, followstatus) => {
    updateList(id, followstatus);
    fetchFollowData(id, followstatus);
  };
  const likeUnlike = (id) => {
    const newData = [...listdata];
    const modifiedData = newData.find((x) => x.id === id);
    modifiedData.UserLikeStatus = "InActive";
    modifiedData.voteUp = modifiedData.voteUp - 1 + 2;
    setListData(newData);
  };

  const onLikeUnlikeSelection = (id, cache) => {
    if (isActionDisabled) return;
    likeUnlike(id);
    fetchVoteUpStatus(id, cache);
  };

  const getWordWithHash = (sentence) => {
    const regex = /(?:^|\s)(#\w+)\b/g;

    // Find all matches in the sentence
    const matches = sentence.match(regex);

    // Return the array of matched words (or an empty array if no matches)
    return matches ? matches.map((match) => match.trim()) : [];
  };

  // Function to format date as "07-Mar-2025 16:47"
  const formatUpdateReminderTime = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  // Function to format date as "07-Mar-2025 4:47 PM"
  const formatJsReminderTime = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12; // Convert 24-hour to 12-hour format
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const amPm = date.getHours() >= 12 ? "PM" : "AM";

    return `${day}-${month}-${year} ${hours}:${minutes} ${amPm}`;
  };

  const isValid = (oldMsg, newMsg, isReminderTimeEqual) => {
    const isAttachmentUpdated = isAttacmentDeleted === "success" ? true : false;
    const cleanOld = (oldMsg || "").trimEnd();
    const cleanNew = (newMsg || "").trimEnd();
    if (
      cleanNew === cleanOld &&
      locationAddress === location?.selectedAddress &&
      isReminderTimeEqual &&
      !attachment &&
      !isAttachmentUpdated
    ) {
      setErrMsg("At least one modification required");
      return false;
    }

    if (props?.isTag) {
      const previousHashArr = getWordWithHash(oldMsg || "");
      const previousHash =
        Array.isArray(previousHashArr) && previousHashArr.length > 0
          ? previousHashArr[0]
          : "";

      const currentHashArr = getWordWithHash(newMsg || "");
      const currentHash =
        Array.isArray(currentHashArr) && currentHashArr.length > 0
          ? currentHashArr[0]
          : "";

      if (previousHash !== currentHash) {
        setErrMsg("You can't create a New hash tag");
        return false;
      }
    }

    return true;
  };

  const saveMessage = async (
    id,
    defaultMsg,
    js_reminder_time,
    Keyword_ID,
    reminder_id,
  ) => {
    try {
      const cleanDefaultMsg = (defaultMsg || "").trimEnd();
      const cleanUpdatedMsg = (updatedMsg || "").trimEnd();
      const originalReminder = js_reminder_time?.trim();
      const isReminderTimeEqual =
        Keyword_ID === "impupdate"
          ? reminderDateAndTime === null
            ? true // Always treat as unchanged when user hasn't picked a new reminder
            : formatJsReminderTime(reminderDateAndTime) === originalReminder
          : true; // Skip check if not "impupdate"
      if (!isValid(cleanDefaultMsg, cleanUpdatedMsg, isReminderTimeEqual)) {
        return;
      }

      const newUpdatedMsg = cleanUpdatedMsg.length > 0 ? cleanUpdatedMsg : cleanDefaultMsg;
      const tempUrl =
        attachment instanceof File ? URL.createObjectURL(attachment) : null;
      const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)[^\s]*)/gi;
      const extractedUrls = newUpdatedMsg ? (newUpdatedMsg.match(urlRegex) || []) : [];

      const isTextModified = cleanUpdatedMsg.length > 0 && cleanUpdatedMsg !== cleanDefaultMsg;
      const isAttachmentAdded = attachment instanceof File;
      const isContentEdited = isTextModified || isAttachmentAdded;

      const updatedMessageList = listdata.map((item) => {
        if (item.id !== id) return item;

        const { newSelectedLocation, ...cleanItem } = item;

        // Build base updated object
        const updated = {
          ...cleanItem,
          Message: newUpdatedMsg,
          msg: newUpdatedMsg,
          url: extractedUrls.length > 0 ? extractedUrls : item?.url,
          locName: location?.selectedAddress || "",
          msgLat: location?.selectedAddress ? location?.latitude || item?.msgLat : "",
          msgLng: location?.selectedAddress ? location?.longitude || item?.msgLng : "",
          ...(isContentEdited ? { edited: 1, updated_time: "1m" } : {}),
        };

        // --- Handle attachment update ---
        if (attachment instanceof File) {
          updated.docName = attachment.name;
          updated.docLocation = tempUrl;
          updated.docTagged = 1;
        } else {
          // keep old file values
          updated.docName = item?.docName;
          updated.docLocation = item?.docLocation;
          updated.docTagged = item?.docTagged;
        }

        // --- Handle reminder update only for impupdate posts ---
        if (Keyword_ID === "impupdate") {
          updated.js_reminder_time = reminderDateAndTime
            ? formatJsReminderTime(reminderDateAndTime)
            : item?.js_reminder_time; // keep existing if no new time
        }

        return updated;
      });
      const formdata = new FormData();
      if (location?.latitude && location?.longitude) {
        const lat = `${location.latitude},${location.longitude}`;
        formdata.append("msgLoc", lat);
      }
      if (location?.selectedAddress) {
        formdata.append("locName", location.selectedAddress);
      }

      formdata.append("userLoc", "");
      if (Keyword_ID === "impupdate") {
        formdata.append("announceID", id);
        formdata.append("message", newUpdatedMsg);
        if (reminderDateAndTime) {
          if (reminder_id !== null) {
            formdata.append("updateReminderId", reminder_id);
          }
          formdata.append(
            "updateReminderTime",
            formatUpdateReminderTime(reminderDateAndTime),
          );
          formdata.append(
            "jsReminderTime",
            formatJsReminderTime(reminderDateAndTime),
          );
        }
        // await API.editUpdate(id, lettersCount);
        const res = await API.editUpdateLocation(formdata);
        if (res?.data?.status === "New Hash") {
          setErrMsg("You can't create a New hash tag");
          return;
        }
      } else {
        formdata.append("messageID", id);
        formdata.append("message", newUpdatedMsg);
        const res = await API.editPostLocation(formdata);
        if (res?.data?.status === "New Hash") {
          setErrMsg("You can't create a New hash tag");
          return;
        }
      }
      if (attachment) {
        const attachmentFormData = new FormData();
        attachmentFormData.append("file", attachment);
        attachmentFormData.append("messageID", id);

        const response = await API.updateAttachment(attachmentFormData);
      }

      setListData(updatedMessageList);
      setEditPostId(null);
      setAttachment(null);
      setErrMsg(null);
      setIsAttacmentDeleted?.(null);
    } catch (error) {
      console.log(error);
    }
  };

  const cancelUpdateMsg = () => {
    removeNewSelectedLocationKey();
    setEditPostId(null);
    setErrMsg(null);
  };

  const updateMessage = (e) => {
    setUpdatedMsg(e.target.value);
    setErrMsg(null);
  };

  const deletePost = (id) => {
    const newUpdatedList = listdata.filter((item) => item.id !== id);
    setListData(newUpdatedList);
  };

  const onEditSelection = (
    id,
    message,
    latitude,
    longitude,
    locationAddress,
  ) => {
    setOpenTextArea(true);
    setEditPostId(id);
    setUpdatedMsg(message ? message.trimEnd() : "");
    setLatitude(latitude);
    setLongitude(longitude);
    setLocationAddress(locationAddress);
    setLocation({
      selectedAddress: locationAddress,
      latitude: latitude,
      longitude: longitude,
    });
  };

  const updateSayCount = (id) => {
    const updatedMessageList = listdata.map((item) => {
      if (String(item.id) === String(id)) {
        const currentCount = Number(item.sayCount) || 0;
        return { ...item, sayCount: currentCount + 1 }; // Update the message
      }
      return item; // Return unchanged items
    });
    if ((data && data.tenantSayStatus !== "E") && hasRestrictionSays !== true) {
      setListData(updatedMessageList);
    }
  };

  const deleteSayCount = (id) => {
    const updatedMessageList = listdata.map((item) => {
      if (String(item.id) === String(id)) {
        const currentCount = Number(item.sayCount) || 0;
        return { ...item, sayCount: Math.max(0, currentCount - 1) }; // Update the message
      }
      return item; // Return unchanged items
    });
    setListData(updatedMessageList);
  };

  const onClickSendEmailOption = (selectedPost) => {
    setEmailPopupOpen(true);
    setSelectedPost(selectedPost);
  };

  const onInviteSelection = (tenantId, id) => {
    if (isActionDisabled) {
      return;
    }
    setInvitesShow(true);
    setInvite(true);
    setTenantId(tenantId);
    setMsgId(id);
  };

  const updateNewSelectedLocation = (newSelectedLoc) => {
    const newData = [...listdata];
    const modifiedData = newData.find((x) => x.id === editPostId);
    if (modifiedData) {
      // modifiedData.locName = newSelectedLoc;
      modifiedData.newSelectedLocation = newSelectedLoc; // Added a temporary key-value pair
    }
    setListData(newData);
  };

  const removeNewSelectedLocationKey = () => {
    const newData = listdata.map((item) => {
      // Create a copy of the object without mutating the original
      const { newSelectedLocation, ...rest } = item; // Destructure and exclude the temporary key
      return rest; // Return the object without the temporary key
    });
    setListData(newData); // Update the state with the cleaned array
  };

  const handleDeleteAttachementDoc = async (id) => {
    try {
      const response = await API.deleteAttachment(id);

      if (response?.data?.status === "success") {
        alert("Attachment deleted successfully!");

        // Update UI immediately without mutating state
        setListData((prevData) =>
          prevData.map((item) =>
            item.id === id
              ? { ...item, docName: null, docLocation: null, docTagged: 0 }
              : item,
          ),
        );
        setIsAttacmentDeleted(response?.data?.status);
        setAttachment(null);
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete attachment.");
    } finally {
      setActiveTooltip(null);
    }
  };

  const notificationStatusArray = selectedPost?.mainuserdata?.notificationStatus
    ? selectedPost.mainuserdata.notificationStatus.split(",")
    : [];

  const mailRestrictionStatus = notificationStatusArray[8] || "";
  const isLightColor = mailRestrictionStatus === "N";

  console.log(`post component list data:`, listdata);

  const enabled = updatedMsg && charCount > 0 && charCount <= 280;
  const sendBtnEnabled = textCount > 0 && textCount <= 280;
  return (
    <React.Fragment>
      {data && Object.keys(data).length !== 0 ? (
        listdata ? (
          listdata.map((result) => (
            <div className={styles.post} key={result?.id}>
              <div className={feedstyles.avatarDetailsMainContainer}>
                <div className={feedstyles.avatarDetailsContainer}>
                  {/* <Avatar
                    src={`${profileImagePath}${result.uimage}`}
                    className={styles.avatar}
                    variant="square"
                  /> */}
                  <div className={feedstyles.avatarContainer}>
                    <AvatarBadge
                      src={
                        result.uimage
                          ? `${profileImagePath}${result.uimage}`
                          : process.env.REACT_APP_DUMMY_PROFILE_IMAGE
                      }
                      className={styles.avatar}
                      variant="square"
                      alt={userDetails?.userData?.displayName}
                      isPrimaryModerator={
                        result.mainuserdata.isPM == 1 &&
                        result.mainuserdata.isModerator == 1
                      }
                      isModerator={
                        result.mainuserdata.isPM == 0 &&
                        result.mainuserdata.isModerator == 1
                      }
                    />
                    <ProfileHoverCard
                      result={result}
                      showData={showData}
                      parentMsgId={parentMsgId}
                      flow={flow}
                      isActionDisabled={isActionDisabled}
                      onActionSuccess={onActionSuccess}
                    />
                  </div>
                  <div style={{ marginLeft: "10px" }}>
                    {isAskModal !== "isAskModal" ? (
                      <span
                        className={feedstyles.profilename}
                        style={{
                          display: "inline-flex",
                          width: "fit-content",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        {result.displayName}

                        {result?.mainuserdata?.isImpactableMember === "yes" && (
                          <img
                            src={alreadyImpactfulMemberImg}
                            alt="Impactful Member"
                            title="Impactful Member"
                            style={{
                              width: "18px",
                              height: "18px",
                              objectFit: "contain",
                              flexShrink: 0,
                            }}
                          />
                        )}
                      </span>
                    ) : (
                      <span
                        className={feedstyles.profilename}
                        style={{
                          display: "inline-flex",
                          width: "fit-content",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        {result.displayName}

                        {result?.mainuserdata?.isImpactableMember === "yes" && (
                          <img
                            src={alreadyImpactfulMemberImg}
                            alt="Impactful Member"
                            title="Impactful Member"
                            style={{
                              width: "18px",
                              height: "18px",
                              objectFit: "contain",
                              flexShrink: 0,
                            }}
                          />
                        )}
                      </span>
                    )}
                    {result.locName || result.newSelectedLocation ? (
                      <div className={styles.locationandtime}>
                        <span className={feedstyles.profiletime}>
                          {result.Message_Time}{" "}
                          {result.edited === 1 && (
                            <span> (edited {result.updated_time})</span>
                          )}
                          {showData === "search" && <img src={dot} alt="dot" />}
                          {!hideTenantName && result.TenantName}
                        </span>
                        <img src={dot} alt="dot" />
                        <span
                          className={styles.locationDet}
                          onClick={() => {
                            if (!isActionDisabled) {
                              handleClickOpen(
                                result.locName,
                                result.msgLat,
                                result.msgLng,
                              );
                            }
                          }}
                          style={{
                            cursor: isActionDisabled ? "default" : "pointer",
                            pointerEvents: isActionDisabled ? "none" : "auto",
                          }}
                        >
                          <img
                            src={locationIcon}
                            alt="location"
                            className={styles.locationIcon}
                          />
                          {result.newSelectedLocation || result.locName}
                        </span>
                      </div>
                    ) : (
                      <span className={styles.locationandtime}>
                        <p className={feedstyles.profiletime}>
                          {result.Message_Time}{" "}
                          {result.edited === 1 && (
                            <span> (edited {result.updated_time})</span>
                          )}
                          {showData === "search" && <img src={dot} alt="dot" />}
                          {!hideTenantName && result.TenantName}
                        </p>
                      </span>
                    )}
                  </div>
                </div>

                {/* edited te things from here  */}
                {!isActionDisabled && (
                <div className={feedstyles.feeddropdown}>
                    {/* <button className={feedstyles.feeddropdownbutton}>
                    <img src={dropdownarrow} alt="dropdown" />
                  </button> */}
                    <Menu
                      portal={true}
                      reposition="auto"
                      position="anchor"
                      viewScroll="close"
                      menuButton={
                        <IconButton
                          style={{
                            padding: 0,
                            width: 30,
                            height: 30,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            outline: "none",
                          }}
                        >
                          {/* <MdKeyboardArrowDown fontSize={25} /> */}
                          <PiDotsThreeBold
                            fontSize={25}
                            color="rgba(0, 0, 0, 0.7)"
                          />
                        </IconButton>
                      }
                      transition
                      direction="bottom"
                      align="end"
                      arrow
                      menuStyle={{
                        backgroundColor: "white",
                        borderRadius: 20,
                      }}
                    >
                      {result.User_ID &&
                        userDetails &&
                        userDetails.userData && (
                          <>
                            {result.User_ID !== userDetails.userData.User_ID ? (
                              <>
                                {(
                                  showData === "search" || hasParentMsgId
                                    ? result.moderatorStatus === "1"
                                    : isModerator
                                ) ? (
                                  <>
                                    {(result.Keyword_ID === "H" ||
                                      result.Keyword_ID === "hashTAG" ||
                                      result.message_type === "X" ||
                                      result.message_type === "H" ||
                                      result.Keyword_ID === "#TAG") && (
                                      <MenuItem>
                                        <ReusuableTagActionModal
                                          type="download"
                                          tagId={result?.id}
                                          tagName={result?.Message}
                                          tagData={result}
                                          onActionSuccess={onActionSuccess}
                                        />
                                      </MenuItem>
                                    )}
                                    {(result.Keyword_ID === "H" ||
                                      result.Keyword_ID === "hashTAG" ||
                                      result.message_type === "X" ||
                                      result.message_type === "H" ||
                                      result.Keyword_ID === "#TAG") && (
                                      <MenuItem>
                                        <ReusuableTagActionModal
                                          type="rating"
                                          tagId={result?.id}
                                          tagName={result?.Message}
                                          tagData={result}
                                          onActionSuccess={onActionSuccess}
                                        />
                                      </MenuItem>
                                    )}
                                    <MenuItem>
                                      <ReusuableDeleteDialogmodal
                                        type={result.Keyword_ID}
                                        id={result.id}
                                        deleteMessage={deleteMessage}
                                        // deletePost={deletePost}
                                        deleteAnswersToAsksDialogPost={
                                          deleteAnswersToAsksDialogPost
                                        }
                                        deleteAsksToBeAnsweredDialogPost={
                                          deleteAsksToBeAnsweredDialogPost
                                        }
                                        fetchContributors={fetchContributors}
                                        postParentId={result.Parent_ID}
                                      />
                                    </MenuItem>
                                    <MenuItem onClick={() =>
                                        onClickSendEmailOption(result)
                                      }>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={sendanemail} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Send email to {result.displayName}</span>
        </div>
      </MenuItem>
                                  </>
                                ) : (
                                  <>
                                    {(result.Keyword_ID === "H" ||
                                      result.Keyword_ID === "hashTAG" ||
                                      result.message_type === "X" ||
                                      result.message_type === "H" ||
                                      result.Keyword_ID === "#TAG") && (
                                      <MenuItem>
                                        <ReusuableTagActionModal
                                          type="download"
                                          tagId={result?.id}
                                          tagName={result?.Message}
                                          tagData={result}
                                          onActionSuccess={onActionSuccess}
                                        />
                                      </MenuItem>
                                    )}
                                    {(result.Keyword_ID === "H" ||
                                      result.Keyword_ID === "hashTAG" ||
                                      result.message_type === "X" ||
                                      result.message_type === "H" ||
                                      result.Keyword_ID === "#TAG") && (
                                      <MenuItem>
                                        <ReusuableTagActionModal
                                          type="rating"
                                          tagId={result?.id}
                                          tagName={result?.Message}
                                          tagData={result}
                                          onActionSuccess={onActionSuccess}
                                        />
                                      </MenuItem>
                                    )}
                                    <MenuItem>
                                      <ReportModal
                                        id={result.id}
                                        param={"AskorSay"}
                                        onActionSuccess={onActionSuccess}
                                      />
                                    </MenuItem>
                                    <MenuItem onClick={() =>
                                        onClickSendEmailOption(result)
                                      }>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={sendanemail} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Send email to {result.displayName}</span>
        </div>
      </MenuItem>
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {(result.Keyword_ID === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X" ||
                                  result.message_type === "H" ||
                                  result.Keyword_ID === "#TAG") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="download"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                      onActionSuccess={onActionSuccess}
                                    />
                                  </MenuItem>
                                )}
                                {(result.Keyword_ID === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X" ||
                                  result.message_type === "H" ||
                                  result.Keyword_ID === "#TAG") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="rating"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                      onActionSuccess={onActionSuccess}
                                    />
                                  </MenuItem>
                                )}
                                <MenuItem onClick={() =>
                                    onEditSelection(
                                      result.id,
                                      result?.Message,
                                      result.msgLat,
                                      result.msgLng,
                                      result.locName,
                                    )
                                  }>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={edit} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="edit" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Edit</span>
        </div>
      </MenuItem>
                                <MenuItem>
                                  <ReusuableDeleteDialogmodal
                                    type={result.Keyword_ID}
                                    id={result.id}
                                    deleteMessage={deleteMessage}
                                    // deletePost={deletePost}
                                    deleteAnswersToAsksDialogPost={
                                      deleteAnswersToAsksDialogPost
                                    }
                                    deleteAsksToBeAnsweredDialogPost={
                                      deleteAsksToBeAnsweredDialogPost
                                    }
                                    fetchContributors={fetchContributors}
                                    postParentId={result.Parent_ID}
                                  />
                                </MenuItem>
                              </>
                            )}
                          </>
                        )}
                    </Menu>
                  </div>
                )}
              </div>
              <div className={styles.avatardescription}>
                {editPostId === result.id ? (
                  <div>
                    <div className={styles.textareaContainer}>
                      <textarea
                        rows="2"
                        cols="50"
                        value={updatedMsg}
                        onChange={(e) => updateMessage(e)}
                        className={styles.EditPostMessage}
                        style={{ marginTop: "15px" }}
                      ></textarea>
                    </div>
                    {errMsg && (
                      <span style={{ fontSize: 11, color: "red" }}>
                        {errMsg}
                      </span>
                    )}
                    <div
                      className={
                        styles.postAttachmentIconsAndActionBtnMainTopContainer
                      }
                    >
                      <div className={styles.saveCancelButtonContainer}>
                        <div className={styles.postAttachmentIconsContainer}>
                          <div
                            className={
                              styles.postLocationAttachmentTextContainer
                            }
                          >
                            <EditLocation
                              postLattitude={latitude}
                              postLongitude={longitude}
                              onLocationChange={handleLocationUpdate}
                              updateNewSelectedLocation={
                                updateNewSelectedLocation
                              }
                            />
                            {location.selectedAddress && (
                              <div className={styles.childfileLocationItem}>
                                <span className={styles.childfileLocationName}>
                                  {location.selectedAddress}
                                </span>
                                <button
                                  type="button"
                                  onClick={handleLocationDelete}
                                  className={styles.removeBtn}
                                >
                                  <img
                                    src={closeIcon}
                                    alt="closeIcon"
                                    className={styles.deleteIcon}
                                  />
                                </button>
                              </div>
                            )}
                          </div>
                          <AttachmentUploader
                            onFileSelect={setAttachment}
                            allowMultiple={false}
                            docName={result?.docName}
                            docLocation={result?.docLocation}
                            onDeleteAttachment={handleDeleteAttachementDoc}
                            editPostId={result?.id}
                          />
                          {result?.Keyword_ID === "impupdate" ? (
                            <EditCalendarComponent
                              setReminderDateAndTime={setReminderDateAndTime}
                              previousReminder={result?.js_reminder_time}
                            />
                          ) : null}
                        </div>
                        {!location.selectedAddress &&
                          !result?.docName &&
                          !attachment && (
                            <div className={styles.saveCancelBtnContainer}>
                              <button
                                onClick={() =>
                                  saveMessage(
                                    result.id,
                                    result.Message,
                                    result?.js_reminder_time,
                                    result?.Keyword_ID,
                                    result?.reminder_id,
                                  )
                                }
                                className={styles.editPost}
                                disabled={!enabled}
                                style={{ opacity: enabled ? 1 : 0.6 }}
                              >
                                Save
                              </button>
                              <button
                                onClick={cancelUpdateMsg}
                                className={styles.editCancelPost}
                              >
                                Cancel
                              </button>
                            </div>
                          )}
                        <span>
                          <label
                            style={{ color: charCount > 280 ? "red" : "black" }}
                          >
                            {charCount}
                          </label>
                          <label>/280</label>
                        </span>
                      </div>
                      {(location.selectedAddress ||
                        result?.docName ||
                        attachment) && (
                        <div
                          className={styles.saveCancelBtnContainer}
                          style={{ margin: "auto" }}
                        >
                          <button
                            onClick={() =>
                              saveMessage(
                                result.id,
                                result.Message,
                                result?.js_reminder_time,
                                result?.Keyword_ID,
                                result?.reminder_id,
                              )
                            }
                            className={styles.editPost}
                            disabled={!enabled}
                            style={{ opacity: enabled ? 1 : 0.6 }}
                          >
                            Save
                          </button>
                          <button
                            onClick={cancelUpdateMsg}
                            className={styles.editCancelPost}
                          >
                            Cancel
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "baseline", // aligns with text bottom
                      flexWrap: "wrap",
                      gap: "5px", // small gap between text and file name
                    }}
                  >
                    <p
                      id={`hide${result.id}`}
                      style={{ marginBottom: "5px", color: "#050505" }}
                    >
                      <TextWithUrlsAndHashTags
                        Message={result.Message}
                        text={result.msg}
                        hashtags={result.tag}
                        urls={result.url}
                        tagActivityTenantId={
                          showData === "search" ? result.TenantID : undefined
                        }
                        onHashtagClick={onHashTagClick}
                      />
                    </p>
                    <PostAttachmentViewer
                      docLocation={result.docLocation}
                      docTagged={result.docTagged}
                      docName={result.docName}
                      messageID={result.id}
                      className={feedstyles.myFileNameSpacingAllFeed}
                      activeTooltip={activeTooltip}
                      setActiveTooltip={setActiveTooltip}
                      onDeleteAttachment={handleDeleteAttachementDoc}
                    />
                  </div>
                )}
              </div>
              {/* Keyword_ID	"Important Update" OpenSAY */}
              <div className={styles.followerandcount}>
                {isPostOption === "SAY" ||
                showData === "tag" ||
                showData === "singleTrendingTag" ||
                showData === "ask" ||
                ((showData === "search" || showData === "tagsearch") &&
                  (result.Keyword_ID === "OpenASK" ||
                    result.Keyword_ID === "Open ASK" ||
                    result.Keyword_ID === "hashTAG" ||
                    result.Keyword_ID === "#TAG")) ? (
                  <div className={feedstyles.followCountMainContainer}>
                    <div className={feedstyles.followCountContainer}>
                      {result?.followCount ? (
                        result.followCount !== 0 ? (
                          <div>
                            <SimpleDialogDemo
                              followCount={result.followCount}
                              id={result.id}
                              status={followData}
                              isActionDisabled={isActionDisabled}
                              onActionSuccess={onActionSuccess}
                            />
                          </div>
                        ) : (
                          <div>
                            <span className={styles.followcount}>
                              {result.followCount} followers
                            </span>
                          </div>
                        )
                      ) : (
                        `0 followers`
                      )}
                      {(result.hashTagType === "private" ||
                        result.Keyword_ID === "X") && (
                        <span className={feedstyles.hashTagType}>
                          <span>
                            <img src={dot} alt="dot" />
                          </span>{" "}
                          Private
                        </span>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className={feedstyles.followCountContainer}>
                    <div className={feedstyles.inlineRow}>
                      {result?.voteUp ? (
                        result.voteUp !== 0 ? (
                          <SimpleDialogDemo
                            voteUp={result.voteUp}
                            id={result.id}
                            isActionDisabled={isActionDisabled}
                            onActionSuccess={onActionSuccess}
                          />
                        ) : (
                          <span className={styles.followcount}>
                            {result.voteUp} likes
                          </span>
                        )
                      ) : (
                        `0 likes`
                      )}
                      {(isPostOption === "ASK" ||
                        result?.Keyword_ID === "Answer" ||
                        result?.Keyword_ID === "Reply") &&
                        result.Parent_ID && (
                          <>
                            <BsDot className={activityStyle.dotIcon} />
                            <button
                              onClick={(e) =>
                                handleClickHashTag(result.Parent_ID, result.id)
                              }
                              className={activityStyle.likeCountContainerButton}
                              type="button"
                            >
                              {result?.Keyword_ID === "Reply"
                                ? result?.hashTag
                                : "ASK"}
                            </button>
                          </>
                        )}
                    </div>
                  </div>
                )}
                {/* {result.Keyword_ID === "Open ASK" ||
                result.Keyword_ID === "OpenASK" ||
                result.Keyword_ID === "ASK" ? (
                  <div className={styles.askcount}>
                    <span>{result.mainuserdata.askcount}</span>
                  </div>
                ) : result.Keyword_ID === "SAY" ||
                  result.Keyword_ID === "OpenSAY" ? (
                  <div className={styles.saycount}>
                    <span></span>
                  </div>
                ) : result.Keyword_ID === "Important Update" ||
                  result.Keyword_ID === "impupdate" ? (
                  <div className={styles.updatecount}>
                    <span></span>
                  </div>
                ) : result.Keyword_ID === "#tag" ||
                  result.Keyword_ID === "hashTAG" ||
                  result.Keyword_ID === "H" ? (
                  <div className={styles.tagcount}>
                    <span>{result.mainuserdata.hashtagcount}</span>
                  </div>
                ) : (
                  ""
                )} */}
                {showData === "tag" ||
                showData === "singleTrendingTag" ||
                ((showData === "search" || showData === "tagsearch") &&
                  (result.Keyword_ID === "hashTAG" ||
                    result.Keyword_ID === "#TAG")) ? (
                  <Tooltip title="TAG" arrow>
                    <div className={styles.tagcount}>
                      <span>
                        {result.childcotentreadcount !== 0
                          ? result.childcotentreadcount
                          : ""}
                      </span>
                    </div>
                  </Tooltip>
                ) : isPostOption === "SAY" ||
                  showData === "ask" ||
                  ((showData === "search" || showData === "tagsearch") &&
                    (result.Keyword_ID === "OpenASK" ||
                      result.Keyword_ID === "Open ASK")) ? (
                  <Tooltip title="ASK" arrow>
                    <div className={feedstyles.readCountContainer}>
                      <p>
                        {result.childcotentreadcount !== 0 &&
                        result.followStatus !== "N"
                          ? result.childcotentreadcount
                          : ""}
                      </p>
                    </div>
                  </Tooltip>
                ) : (
                  <>
                    {result.Keyword_ID === "impupdate" ||
                    result.Keyword_ID === "Important Update" ||
                    result.Keyword_ID === "I" ? (
                      <Tooltip title="UPDATE" arrow>
                        <div className={styles.updateCountContainer} />
                      </Tooltip>
                    ) : !result.Parent_ID ? (
                      <Tooltip title="SAY" arrow>
                        <div className={styles.saycount} />
                      </Tooltip>
                    ) : null}
                  </>
                )}
              </div>

              <Divider variant="fullWidth" />
              {isPostOption === "SAY" ||
              showData === "tag" ||
              showData === "singleTrendingTag" ||
              showData === "ask" ||
              ((showData === "search" || showData === "tagsearch") &&
                (result.Keyword_ID === "OpenASK" ||
                  result.Keyword_ID === "Open ASK" ||
                  result.Keyword_ID === "#TAG" ||
                  result.Keyword_ID === "hashTAG")) ? (
                <div className={styles.saysandfollow}>
                  <div className={styles.noOfsays}>
                    {/* <img src-={dots} alt="saysdots"/> */}
                    <a onClick={(e) => onSayClick(result.id, e)}>
                      <img
                        src={
                          isPostOption === "SAY" ||
                          showData === "ask" ||
                          result.Keyword_ID === "OpenASK" ||
                          result.Keyword_ID === "Open ASK"
                            ? answerIcon
                            : replyIcon
                        }
                        className={
                          isPostOption === "SAY" ||
                          showData === "ask" ||
                          result.Keyword_ID === "OpenASK" ||
                          result.Keyword_ID === "Open ASK"
                            ? styles.answerIcon
                            : styles.replyIcon
                        }
                        alt="number of says"
                      />
                      <span>
                        {isPostOption === "SAY" ||
                        showData === "ask" ||
                        result.Keyword_ID === "OpenASK" ||
                        result.Keyword_ID === "Open ASK"
                          ? result.sayCount === 0
                            ? "Answer"
                            : `${result.sayCount} ${
                                result.sayCount === 1 ? "Answer" : "Answers"
                              }`
                          : result.sayCount === 0
                            ? "Reply"
                            : `${result.sayCount} ${
                                result.sayCount === 1 ? "Reply" : "Replies"
                              }`}
                      </span>
                    </a>
                  </div>
                  <div className={styles.noOffollows}>
                    {result.followStatus === "N" ||
                    result.followStatus === "inactive" ? (
                      <>
                        <div
                          className={`${feedstyles.noOffollows}`}
                          id={`1${result.id}`}
                        >
                          <a
                            className={styles.followtext}
                            onClick={() =>
                              followunfollow(result.id, "isFollow=1")
                            }
                          >
                            <img src={follow} alt="follow" />{" "}
                            <span>Follow</span>
                          </a>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className={`${feedstyles.noOffollows} `}
                          id={`0${result.id}`}
                        >
                          <a
                            className={styles.followtext}
                            onClick={() =>
                              followunfollow(result.id, "isFollow=0")
                            }
                          >
                            <img src={unfollow} alt="unfollow" />{" "}
                            <span>Unfollow</span>
                          </a>
                        </div>
                      </>
                    )}
                  </div>
                  {(result.hashTagType === "private" ||
                    result.Keyword_ID === "X") &&
                  (props.parentMsgId
                    ? (result.isPM == 1 && result.isModerator == 1) ||
                      (result.isPM == 0 && result.isModerator == 1)
                    : userDetails.userData.moderatorStatus === "1" ||
                      userDetails.userData.isAdmin === "1") ? (
                    <div
                      className={feedstyles.priavteinvite}
                      onClick={() =>
                        onInviteSelection(
                          result.TenantID ||
                            result.tenantID ||
                            allTagData.tenantID,
                          result.id,
                        )
                      }
                    >
                      <img src={privateinvite} alt="Private Invite" />
                      <span style={{ cursor: "pointer" }}>Invite</span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div className={styles.likeunlike}>
                  {result.UserLikeStatus === "Active" ? (
                    <>
                      <a
                        onClick={() =>
                          onLikeUnlikeSelection(result.id, "cacheUpdate")
                        }
                        id={`like${result.id}`}
                      >
                        <img src={like} alt="like" />
                        Like
                      </a>
                      {/* <a
                        className={feedstyles.likedisplay}
                        id={`unlike${result.id}`}
                      >
                        <img src={unlike} alt="unlike" />
                        Like
                      </a> */}
                    </>
                  ) : (
                    <a>
                      <img src={unlike} alt="unlike" />
                      Like
                    </a>
                  )}
                </div>
              )}
              {/* .......................childsaydata ......................*/}

              {(result.Keyword_ID === "OpenASK" ||
                result.Keyword_ID === "Open ASK" ||
                result.Keyword_ID === "#TAG" ||
                result.Keyword_ID === "hashTAG" ||
                result.Keyword_ID === "H" ||
                result.Keyword_ID === "TrendingASK" ||
                result.Keyword_ID === "ASK") && (
                <div
                  className={styles.childsayselection}
                  id={`saySelection${result.id}${props?.appendId ?? ""}`}
                  ref={(el) => (sayRefs.current[result.id] = el)} // Store each element in the ref array
                >
                  {/* .....when we click on say something on post ......................*/}
                  {currentSayId === result.id && (
                    <PostMessageValidation
                      listdata={listdata}
                      refreshFeedData={refreshFeedData}
                      fetchChildSaysData={fetchChildSaysData}
                      id={result.id}
                      type={"childSay"}
                      readOnly={isActionDisabled}
                      userImageSrc={`${profileImagePath}${userDetails?.userData?.uimage}`}
                      postChildSayData={postChildSayData}
                      updateSayCount={updateSayCount}
                      fetchContributors={fetchContributors}
                      shouldUseModeratorStatus={shouldUseModeratorStatus}
                      keywordName={result.Keyword_ID}
                      {...((showData === "search" ||
                        parentMsgId !== undefined ||
                        tagActivityTenantId !== undefined) && {
                        postData: result,
                      })}
                    />
                  )}

                  {/* <div className={styles.comment}>
                                        <Avatar src={profileimage} variant="square" />

                                        <input className={styles.commentinput} placeholder="Say something..." type="text" />
                                        <a><img src={locationpinchildpost} /></a>
                                    </div>
                                    <div>
                                        <button className={styles.childpost}>POST</button>
                                    </div> */}
                  {currentSayId === result.id && (
                    <Childsay
                      id={result.id}
                      deleteMessage={deleteMessage}
                      refreshFeedData={refreshFeedData}
                      loading={loading}
                      childSaysData={childSaysData}
                      fetchVoteUpStatus={fetchVoteUpStatus}
                      flow={flow}
                      sayOrAskPost={"sayOrAskPost"}
                      deleteSayCount={deleteSayCount}
                      fetchContributors={fetchContributors}
                      isActionDisabled={isActionDisabled}
                      onActionSuccess={onActionSuccess}
                      onHashTagClick={onHashTagClick}
                    />
                  )}
                </div>
              )}
            </div>
          ))
        ) : (
          <p>No data found</p>
        )
      ) : (
        ""
      )}

      {invitesShow && (
        <InviteFollowers
          show={invitesShow}
          onHide={() => setInvitesShow(false)}
          invite={invite}
          tenantid={tenantId}
          msgid={msgId}
        />
      )}

      <Modal
        show={emailPopupOpen}
        style={{ backgroundColor: "#00000060", zIndex: 4000 }}
      >
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#fff" }}
          onClick={() => setEmailPopupOpen(false)}
        >
          <Modal.Title>Send email</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {mailRestrictionStatus === "N" ? (
            <p>{`${selectedPost?.displayName} is not accepting emails`}</p>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <textarea
                rows="6"
                cols="44"
                className={styles.sendamailtextarea}
                id={`textInputMail${selectedPost?.id}`}
                // onInput={() => myFunction(props.id)}
                value={textValue}
                onChange={(e) => setUpdatedText(e)}
                placeholder={`What would you like to say to ${selectedPost?.displayName}`}
                // maxLength={280}
              />
              <label style={{ textAlign: "end", width: "100%" }}>
                <label style={{ color: textCount > 280 ? "red" : "black" }}>
                  {textCount}
                </label>
                /280
              </label>
              <button
                type="button"
                id={`buttonforEdit${selectedPost?.id}`}
                className={styles.sendaMail}
                style={{ left: 0, opacity: sendBtnEnabled ? 1 : 0.6 }}
                onClick={() => onSendMail(selectedPost?.id)}
                disabled={!sendBtnEnabled}
              >
                Send
              </button>
            </div>
          )}
        </Modal.Body>
      </Modal>
      <MapDialog
        open={openMap}
        onClose={handleCloseMap}
        clickedLocation={clickedLocation}
        zoomLevel={12}
      />
      {open && popupPostId && (
        <PopupComponent
          popupData={popupData}
          setPopupData={setPopupData}
          followunfollow={followunfollowParentAskPost}
          open={open}
          onClose={onClosePopup}
          postId={popupPostId}
          deletePopupMessage={deletePopupMessage}
          filtertype="activityTag"
        />
      )}

      {showUnfollowAlert && (
        <ConfirmationDialog
          open={true}
          handleClose={() => setShowUnfollowAlert(null)}
          type={"warning"}
          title={"Are you sure you want to Unfollow?"}
          acceptLabel={"Yes"}
          onAccept={() => {
            followunfollowCallback(
              showUnfollowAlert?.id,
              showUnfollowAlert?.followstatus,
            );
            setShowUnfollowAlert(null);
          }}
        />
      )}
    </React.Fragment>
  );
});

export default Post;
